import { Component, effect } from '@angular/core';
import { UserService } from '../../user.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { UserInfo } from '../../user-info/user-info';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommunityCalendar } from '../community-calendar/community-calendar';
import { PaymentsOverview } from '../payments-overview/payments-overview';


@Component({
  selector: 'app-pay-my-rent',
 imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo, CommunityCalendar, PaymentsOverview],
  templateUrl: './pay-my-rent.html',
  styleUrl: './pay-my-rent.scss'
})
export class PayMyRent {

	
	public Current_balance: number = 20000;
	public Next_Payment_Date : Date = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);

	public pastPayments = [
		{ date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000), amount: 20000 },
	];

}
